import { useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'

import { QA_NAME_ATTACH_BTN, QA_NAME_CANCEL_BTN } from '../../constants/qa'
import { TableRowActions } from '../Table'
import { TableModal, TableModalSearch } from '../TableModal'

import {
  QA_NAME_DOC_FLOW_SELECT_MODAL,
  QA_NAME_DOC_FLOW_SELECT_MODAL_CONNECT,
  QA_NAME_DOC_FLOW_SELECT_MODAL_DISCONNECT,
} from './DocFlowSelectModal.constants'
import { useDocFlowSelectModal } from './DocFlowSelectModal.hooks'
import { DocFlowSelectModalTableRow } from './DocFlowSelectModalTableRow'

import * as styles from './DocFlowSelectModal.module.css'

import DocFlowIcon from '../../icons/doc-splitting.svg'

function DocFlowSelectModal({
  Actions,
  Search = TableModalSearch,
  actionsProps,
  counterProps,
  entityId,
  excludeIds,
  headerProps,
  loadItems,
  ref,
  showLimitNotification,
  onAttach,
  onClose,
}) {
  const { t } = useTranslation()

  const {
    handleAttach,
    handleCloseTableModal,
    isCloseConfirm,
    loadData,
    setCloseConfirm,
    setNotificationListRef,
    tableColumns,
  } = useDocFlowSelectModal({
    entityId,
    excludeIds,
    loadItems,
    showLimitNotification,
    onAttach,
    onClose,
  })

  const {
    checkIsItemSelected,
    handleChangePagination,
    handleChangeSearchValue,
    handleClearSearch,
    handleLoadItems,
    handleSelect,
    handleSelectAll,
    handleSetOrdering,
    handleUnselectAllPages,
    isAllSelected,
    isInitiatedError,
    isInitLoading,
    isRemoveSelection,
    loading,
    notifications,
    ordering,
    pagination,
    search,
    selected,
    setLoading,
    tableItems,
  } = loadData

  useImperativeHandle(ref, () => ({
    refresh: handleLoadItems,
    selected,
    setLoading,
    unselectAll: handleUnselectAllPages,
  }))

  return (
    <TableModal
      {...(counterProps
        ? { counterProps: { ...counterProps, count: pagination?.count } }
        : null)}
      initialFullScreen
      Actions={Actions}
      Search={Search}
      SelectionToolbar={null}
      actionsProps={{
        ...actionsProps,
        buttonAttachProps: {
          ...actionsProps?.buttonAttachProps,
          isLoading: loading,
          qaName: QA_NAME_ATTACH_BTN,
          text:
            actionsProps?.buttonAttachProps?.text ||
            'Modal.ConnectDocFlowsSubmitBtnKey',
          onClick: handleAttach,
        },
        buttonCancelProps: {
          qaName: QA_NAME_CANCEL_BTN,
          onClick: handleCloseTableModal,
        },
        buttonConnectProps: {
          ...actionsProps?.buttonConnectProps,
          qaName: QA_NAME_DOC_FLOW_SELECT_MODAL_CONNECT,
        },
        buttonDisconnectProps: {
          ...actionsProps?.buttonDisconnectProps,
          qaName: QA_NAME_DOC_FLOW_SELECT_MODAL_DISCONNECT,
        },
      }}
      contentProps={{ loading }}
      emptyStateProps={{
        EntityIcon: DocFlowIcon,
        className: styles.emptyState,
        text: t('Modal.DocFlowSelectModalNoDataKey'),
      }}
      headerProps={{
        ...headerProps,
        text: headerProps?.text || 'Modal.ConnectDocFlowsTitleKey',
        onClose: handleCloseTableModal,
      }}
      isCloseConfirm={isCloseConfirm}
      isInitiatedError={isInitiatedError}
      isInitLoading={isInitLoading}
      loading={loading}
      notificationListProps={{
        ref: setNotificationListRef,
      }}
      notifications={notifications}
      paginationProps={{ pagination, onChange: handleChangePagination }}
      qaName={QA_NAME_DOC_FLOW_SELECT_MODAL}
      searchProps={{
        placeholder: 'Modal.DocFlowSelectModalSearchPlaceholderKey',
        value: search,
        onChange: handleChangeSearchValue,
        onClear: handleClearSearch,
      }}
      selected={selected}
      setCloseConfirm={setCloseConfirm}
      tableItems={tableItems?.items}
      tableItemsCount={pagination.page}
      tableProps={{
        TableRow: DocFlowSelectModalTableRow,
        checkIsItemSelected,
        className: styles.table,
        columns: tableColumns,
        headerRowProps: {
          Actions: TableRowActions,
          actionsProps: {
            checked: isAllSelected,
            selected: isRemoveSelection,
            onChange: handleSelectAll,
          },
          ordering,
          resizable: false,
          withCellBorder: false,
          onSetOrdering: handleSetOrdering,
        },
        items: tableItems?.items,
        rowProps: {
          onSelect: handleSelect,
        },
      }}
      onApplyConfirmModal={onClose}
      onRefresh={handleLoadItems}
      onTableModalClose={handleCloseTableModal}
    />
  )
}

export default DocFlowSelectModal
